import { useContext } from 'react';
import { NavbarMenuListContext } from './NavbarMenuListContext';

export const useNavbarMenuListContext = () => {
  const context = useContext(NavbarMenuListContext);
  if (!context) {
    console.error(new Error('useNavbarMenuListContext must be used within a NavbarMenuListContextProvider'));
    return {
      middleWrapperHeight: 0,
      setMiddleWrapperHeight: () => {},
    };
  }
  return context;
};
